<div *ngIf="loadingService.isLoading$ | async">
  <div class="loader"></div>
  <div class="load-overlay"></div>
</div>

